import React from 'react'
import axios from 'axios'

const getChat = async ({ setChatLoading, setAnswer, setBackEvents, question }) => {
    setChatLoading(true)
    setBackEvents(false)
    setAnswer('')

    const cancelToken = axios.CancelToken.source()

    await axios.post('https://www.thewordartisan.online/api/v1/result', {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Headers": "Content-Type",
            "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
            "Content-Type": "application/json",
            Authorization: `Bearer ${'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2M2I3YmU5MDJkNmExNDJmZGE3MzY4MDciLCJlbWFpbCI6InN5ZG5leTExODIyN0BpY2xvdWQuY29tIiwiaWF0IjoxNjc0MTAyMjc1fQ.dCQA2R-BAQ_vWdRtkAEcgs2QQkSBaK1cheJB153anqs' ?? null}`
        },
        text: `\nQ:${question}-\nA:`, token: 1000
    },
    {
        cancelToken: cancelToken.token
    })

    .then((response) => {
        const data = response.data.result.data

        if (data) {
            setAnswer(data)
        } else {
            setAnswer('Perdona pero el genio no ha podido responder. Prueba nuevamente.')
        }
        
        setChatLoading(false)
    })
    
    .catch((err) => {
        if (axios.isCancel(err)) {
            console.log("Axios post cancelled!")
            setAnswer('Perdona pero el genio no ha podido responder. Prueba nuevamente.')
        } else {
            console.log(err)
            setAnswer('Perdona pero el genio no ha podido responder. Prueba nuevamente.')
        }
        
        setChatLoading(false)
    })
}

export default getChat